// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const lang = window.navigator.language;

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: require('../src/style/i18n/en.json')
      },
      fr: {
        translation: require('../src/style/i18n/fr.json')
      }
    },
    lng: lang === 'fr' || lang === 'en' ? lang : 'fr',
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;

